import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ParameterBackupModalComponent from './ParameterBackupComponent';
import { getModel } from './selectors';
import * as parameterBackupActions from './actions';
import { parameterBackupRequest } from './../../../../PowertrainTools/GatewayManagement/GatewayDetails/ConnectedAssets/ConnectedAssetsDrives/ParameterBackup/actions';


const ParameterBackupContainer = (props) => {
	return <ParameterBackupModalComponent {...props} />;
};

const mapStateToProps = (state) => {
	const model = getModel(state);
	return { model };
};

const mapDispatchToProps = (dispatch) => {
	return {
		actions: bindActionCreators(
			{
				...parameterBackupActions,
				triggerParameterBackup: parameterBackupRequest
			},
			dispatch
		)
	};
};

const ComponentsParameterBackupContainerConn = connect(
	mapStateToProps,
	mapDispatchToProps
)(ParameterBackupContainer);

export default ComponentsParameterBackupContainerConn;

// eslint-disable-next-line import/no-unused-modules
export { mapStateToProps, mapDispatchToProps };
